// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autograder-page {
    font-family: Arial, sans-serif;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: beige;
}

h1 {
    text-align: center;
    color: #333;
}

  
  .graderbot-logo {
    width: 100px; /* Adjust to an appropriate size */
    height: auto;
    margin-right: 20px; /* Space between the logo and title */
  }
  
  .graderbot-title {
      font-size: 2.5rem; /* Adjust title font size */
      margin: 0;
      color: #005c69;
  }
  
  .graderbot-header {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 2rem;
      color: #005c69;
      width: 100%;
      max-width: 800px;
      text-align: center;
      margin-bottom: 30px;
  }

#description {
    font-size: 16px;
    margin-bottom: 20px;
}

#description input {
    font-size: 16px;
    padding: 5px;
    margin-left: 5px;
    margin-right: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.layout-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    background-color: beige;
}

.box {
    background: #dcca98;
    border: 3px solid #144044;
    border-radius: 4px;
    padding: 20px;
    margin: 10px;
    flex: 1 1;
    min-width: 250px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.box h2 {
    margin-top: 0;
    font-size: 18px;
}

.upload-details {
    font-size: 14px;
    color: #222222;
}

#uploadButton,
#generate-button {
    background-color: #144044;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    margin: 20px 0;
    display: block;
    width: 100%;
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

#uploadButton:disabled,
#generate-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.response-container {
    margin-top: 20px;
}

.response-container p {
    text-align: center;
    color: #144044;
}

.export-button {
    margin-top: 20px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/AutoGrader/AutoGraderPage.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;;EAGE;IACE,YAAY,EAAE,kCAAkC;IAChD,YAAY;IACZ,kBAAkB,EAAE,qCAAqC;EAC3D;;EAEA;MACI,iBAAiB,EAAE,2BAA2B;MAC9C,SAAS;MACT,cAAc;EAClB;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;MACnB,cAAc;MACd,WAAW;MACX,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;EACvB;;AAEF;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,SAAO;IACP,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".autograder-page {\n    font-family: Arial, sans-serif;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    background-color: beige;\n}\n\nh1 {\n    text-align: center;\n    color: #333;\n}\n\n  \n  .graderbot-logo {\n    width: 100px; /* Adjust to an appropriate size */\n    height: auto;\n    margin-right: 20px; /* Space between the logo and title */\n  }\n  \n  .graderbot-title {\n      font-size: 2.5rem; /* Adjust title font size */\n      margin: 0;\n      color: #005c69;\n  }\n  \n  .graderbot-header {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 2rem;\n      color: #005c69;\n      width: 100%;\n      max-width: 800px;\n      text-align: center;\n      margin-bottom: 30px;\n  }\n\n#description {\n    font-size: 16px;\n    margin-bottom: 20px;\n}\n\n#description input {\n    font-size: 16px;\n    padding: 5px;\n    margin-left: 5px;\n    margin-right: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.layout-container {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    background-color: beige;\n}\n\n.box {\n    background: #dcca98;\n    border: 3px solid #144044;\n    border-radius: 4px;\n    padding: 20px;\n    margin: 10px;\n    flex: 1;\n    min-width: 250px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.box h2 {\n    margin-top: 0;\n    font-size: 18px;\n}\n\n.upload-details {\n    font-size: 14px;\n    color: #222222;\n}\n\n#uploadButton,\n#generate-button {\n    background-color: #144044;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    margin: 20px 0;\n    display: block;\n    width: 100%;\n    max-width: 200px;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n}\n\n#uploadButton:disabled,\n#generate-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.response-container {\n    margin-top: 20px;\n}\n\n.response-container p {\n    text-align: center;\n    color: #144044;\n}\n\n.export-button {\n    margin-top: 20px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
